// import external modules
import { combineReducers } from "redux";
import loginReducer from "./login/loginReducer";
import GymReducer from "./gym/gymReducer";
import { reducer as toastrReducer } from "react-redux-toastr";
import SubscriptionPlanReducer from "./subscriptionPlan/subscriptionPlanReducer";
import TrainerReducer from "./trainer/trainerReducer";
import SelectReducer from "./selectReducer";
import PackageReducer from "./package/packageReducer";
// import MemberReducer from './member/memberReducer';
// import MemberReducer from './member/memberReducer';
import MemberReducer from "./member/memberReducer";
import WodReducer from "./wod/wodReducer";
import FollowupProgramReducer from "./followupProgram/followupProgramReducer";
import ClassReducer from "./class/classReducer";
import ProductReducer from "./product/productReducer"
import sidebarReducer from "./sidebar/sidebarReducer";
import NotificationReducer from "./notification/notificationReducer";
import SubscribedUsersReducer from "./subscribedUsers/subscribedUsersReducer";
import TrainerDashboardReducer from "./trainerDashboard/trainerDashboardReducer";
import GymDashboardReducer from "./gymDashboard/gymDashboardReducer";
import StaffReducer from "./staff/staffReducer";
import ReportReducer from "./report/reportReducer";
import PermissionReducer from "./permissions/permissonReducer";
import InvoiceReducer from "./invoice/invoiceReducer";
import GymFeaturesReducer from "./gymFeatures/gymFeaturesReducer";
import MembershipCardReducer from "./membershipCard/membershipCardReducer";
import paymentGateways from "./paymentGateways/paymentGatewaysReducer";
import paymentGatewaysFields from "./paymentGateways/paymentGatewaysFieldsReducer";
import paymentGatewayFieldsValue from "./paymentGateways/PaymentGatewayFieldsValueReducer";
import paymentGatewaySaveValueFields from "./paymentGateways/paymentGatewaySaveValueFields";
import paymentGatewaysUsed from "./paymentGateways/paymentGatewaysUsedReducer";
import GateReducer from "./gate/gateReducer";
import payRoll from "./payRoll/payRollReducer";
import CourtReducer from "./court/courtReducer";
import CommonReducer from "./common/commonReducer"; // This seems to be a mistake, it should be CourtReducer
import StaffSessionReducer from "./staffSession/staffSessionReducer";
import BodyMeasurementsReducer from "./bodyMeasurements/bodyMeasurementsReducer";
import InBodyTestReducer from "./inBodyTest/inBodyTestReducer";
import VideosLibraryReducer from "./videosLibrary/videosLibraryReducer";
import MedicalTemplateReducer from "./templates/assessmentTemplateReducer";
import AttachmentLibraryReducer from "./attachmentibrary/attachmentLibraryReducer";
import LeadReducer from "./lead/leadReducer";

const appReducer = combineReducers({
  login: loginReducer,
  toastr: toastrReducer, // <- Mounted at toastr.
  sidebar: sidebarReducer,
  select: SelectReducer,
  plan: SubscriptionPlanReducer,
  gym: GymReducer,
  trainer: TrainerReducer,
  packages: PackageReducer,
  member: MemberReducer,
  notification: NotificationReducer,
  // member: MemberReducer,
  wod: WodReducer,
  class: ClassReducer,
  product:ProductReducer,
  subscribedUsers: SubscribedUsersReducer,
  trainerDashboardData: TrainerDashboardReducer,
  gymDashboardData: GymDashboardReducer,
  staff: StaffReducer,
  report: ReportReducer,
  permissions: PermissionReducer,
  invoice: InvoiceReducer,
  features: GymFeaturesReducer,
  membershipCard: MembershipCardReducer,
  paymentGateways: paymentGateways,
  paymentGatewaysFields: paymentGatewaysFields,
  paymentGatewayFieldsValue: paymentGatewayFieldsValue,
  paymentGatewaySaveValueFields: paymentGatewaySaveValueFields,
  paymentGatewaysUsed: paymentGatewaysUsed,
  gate: GateReducer,
  payRoll: payRoll,
  court: CourtReducer,
  common: CommonReducer,
  staffSession: StaffSessionReducer,
  followupProgram: FollowupProgramReducer,
  bodyMeasurements: BodyMeasurementsReducer,
  inBodyTest: InBodyTestReducer,
  videosLibrary: VideosLibraryReducer,
  attachmentLibrary:AttachmentLibraryReducer,
  medicalTemplate:MedicalTemplateReducer,
  leads: LeadReducer,
});

const rootReducer = (state, action) => {
  // when a logout action is dispatched it will reset redux state
  if (action.type === "USER_LOGGED_OUT_SET_INITIAL") {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
